import { z } from 'zod';
import { ApplicationStatus, ContractStatus, OtpPurpose, Provider } from '../enums.js';
import { ikpuSchema, tiyinSchema } from './common.js';
/**
 * Shartnoma rasmiylashtirish (BT §6.3, 5–6-bosqichlar).
 *
 * Oqim: ariza yaratiladi → provayder mijozga OTP yuboradi → sotuvchi kodni
 * kiritadi → shartnoma tuziladi.
 *
 * Provayder tomonidagi qadamlar adapter ichida qoladi: Alif uchun bu
 * `installment` OTP'si, Uzum uchun oferta bilan rozilik. Frontend ikkalasini
 * bir xil ko'radi.
 */
/** Shartnomaga kiradigan bitta tovar. */
export const contractItemSchema = z.object({
    name: z.string().trim().min(1, 'v.itemName'),
    /**
     * TODO(mijoz): tovar katalogi qayerdan olinadi — BT'da yoritilmagan
     * (MIJOZGA_KERAKLI_MALUMOTLAR.md §5.4). Hozircha qo'lda kiritiladi.
     */
    ikpu: ikpuSchema.optional(),
    /**
     * Do'kondagi tovar kodi. Alif arizada majburiy deb belgilagan.
     * ASKO katalogida bu `ItemCode` (masalan `SHN0793`).
     */
    sku: z.string().trim().min(1).optional(),
    quantity: z.number().int('v.quantity').positive('v.quantity').default(1),
    /** Dona narxi, tiyinda. */
    price: tiyinSchema,
    serialNumber: z.string().trim().optional(),
});
/** Tovarlar yig'indisi, tiyinda. */
export function itemsTotal(items) {
    return items.reduce((sum, item) => sum + item.price * item.quantity, 0);
}
/** POST /api/applications — ariza yaratish va OTP so'rash. */
export const createApplicationRequestSchema = z
    .object({
    /** Qaysi scoring natijasi bo'yicha — provayder o'sha yerdan olinadi. */
    sessionId: z.string().uuid(),
    items: z.array(contractItemSchema).min(1, 'v.itemsMin'),
    /** Tanlangan shart identifikatori (provayder bergan `limits[]` dan). */
    conditionId: z.string().min(1, 'v.required'),
    /** Muddat — oylarda. */
    duration: z.number().int('v.duration').positive('v.duration'),
    /** Umumiy summa, tiyinda. Tovarlar yig'indisiga teng bo'lishi tekshiriladi. */
    amount: tiyinSchema,
})
    .refine((v) => v.amount === itemsTotal(v.items), {
    message: 'v.amountMismatch',
    path: ['amount'],
});
/** POST /api/applications/:id/confirm — mijoz aytgan kod. */
export const confirmApplicationRequestSchema = z.object({
    code: z.string().regex(/^\d{4,6}$/, 'v.contractOtpCode'),
});
export const otpSessionSchema = z.object({
    id: z.string().uuid(),
    provider: z.enum([Provider.ALIF, Provider.UZUM]),
    purpose: z.nativeEnum(OtpPurpose),
    status: z.string(),
    attempts: z.number().int().nonnegative(),
    maxAttempts: z.number().int().positive(),
    expiresAt: z.string().datetime(),
    /**
     * FAQAT `mock` rejimda to'ladi. Real rejimda kodni provayder to'g'ridan-
     * to'g'ri mijozga yuboradi va biz uni bilmaymiz.
     */
    mockCode: z.string().optional(),
});
export const applicationSchema = z.object({
    id: z.string().uuid(),
    provider: z.enum([Provider.ALIF, Provider.UZUM]),
    status: z.nativeEnum(ApplicationStatus),
    amount: tiyinSchema,
    duration: z.number().int().positive(),
    items: z.array(contractItemSchema),
    contractNumber: z.string().nullable(),
    createdAt: z.string().datetime(),
});
export const contractSchema = z.object({
    id: z.string().uuid(),
    applicationId: z.string().uuid(),
    number: z.string(),
    status: z.nativeEnum(ContractStatus),
    /** Shartnoma/akt PDF havolasi. Shablon kelmaguncha `null`. */
    pdfUrl: z.string().nullable(),
    signedAt: z.string().datetime().nullable(),
});
/** Uchala endpoint ham shu ko'rinishda javob beradi — frontendда bitta holat. */
export const applicationStateSchema = z.object({
    application: applicationSchema,
    /** Kod kutilayotgan bo'lsa to'ladi. */
    otp: otpSessionSchema.nullable(),
    /** Shartnoma tuzilgach to'ladi. */
    contract: contractSchema.nullable(),
});
//# sourceMappingURL=contract.js.map